module.exports = __webpack_public_path__ + "img/3.7069f14e.jpg";